import { useEffect } from "react";
import Clarity from "@microsoft/clarity";

import { CLARITY_ID } from "@/env";

// FAC-6458: Clarity runs next to LogRocket for a 4 week trial. Masking is set
// to "Strict" in the Clarity project settings, not here.
// It runs in any environment that has a CLARITY_ID. Prod and the lower
// environments use separate Clarity projects, so test sessions stay out of
// the prod recordings. No CLARITY_ID means Clarity stays off.
const MicrosoftClarity = () => {
  useEffect(() => {
    if (CLARITY_ID) {
      Clarity.init(CLARITY_ID);
    }
  }, []);

  return null;
};

export default MicrosoftClarity;
